module.exports = __webpack_public_path__ + "img/spectranet.9c2fc3c9.png";